module.exports = __webpack_public_path__ + "d77bc1cac748a6b8d68380fe6886a0c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vectorROSEWINE.jpg
// module id = 1128
// module chunks = 1